<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="$route.params.id ? $t('Edit Customer') : $t('New Customer')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <div class="required">
              <v-text-field
                v-model="formValues.name"
                :label="$t('Name') + '*'"
                v-validate="'required'"
                required
                data-vv-name="name"
                :error-messages="errors.collect('name')"
              ></v-text-field>
            </div>
            <v-text-field
              v-model="formValues.street"
              :label="$t('Street')"
              v-validate="''"
              data-vv-name="street"
              :error-messages="errors.collect('street')"
            ></v-text-field>
            <div class="required">
              <v-text-field
                v-model="formValues.city"
                :label="$t('City') + '*'"
                v-validate="'required'"
                required
                data-vv-name="city"
                :error-messages="errors.collect('city')"
              ></v-text-field>
            </div>
            <div class="required">
              <v-text-field
                v-model="formValues.zip"
                :label="$t('Zip') + '*'"
                v-validate="'required'"
                required
                data-vv-name="zip"
                :error-messages="errors.collect('zip')"
              ></v-text-field>
            </div>
            <v-text-field
              v-model="formValues.email"
              label="Email"
              data-vv-name="email"
              :error-messages="errors.collect('email')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.phone"
              :label="$t('Phone')"
              data-vv-name="phone"
              :error-messages="errors.collect('phone')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.number"
              :label="$t('customer_number')"
              data-vv-name="number"
              :error-messages="errors.collect('number')"
            ></v-text-field>
            <div class="required">
              <v-select
                v-if="$auth.check('customer.editall')"
                v-model="formValues.company_id"
                :items="companies"
                :label="$t('Firma') + '*'"
                item-text="name"
                v-validate="'required'"
                required
                data-vv-name="company_id"
                :error-messages="errors.collect('company_id')"
                item-value="id"
              ></v-select>
            </div>
            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="$router.push({ name: 'customer.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem, fetchCompanies } from "../shared/services";
export default {
  name: "app-customer-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        name: ""
      },
      permissions: [],
      loading: true,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false }
      ],
      companies: []
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
    if (this.$auth.check("customer.editall")) {
      fetchCompanies({ page: 1, itemsPerPage: "-1" }).then(res => {
        this.companies = res.data;
      });
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "customer.index" });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
